import React, { useCallback, useEffect } from "react"
import { Col, Form, Row } from "react-bootstrap"
import { useTranslation } from 'react-i18next'
import { useAppointmentState } from '../../../stores/AppointmentProvider'
import MandatoryField from '../../MandatoryField/MandatoryField'
import usePrevious from "../../../utils/hooks/usePrevious"

const UserData = () => {
    const { appointment, setAppointment, userData, phoneError, setPhoneError } = useAppointmentState()
    const { t } = useTranslation()
    const prevData = usePrevious({ userData })

    const memoizedSetPhoneError = useCallback((value) => setPhoneError(value), [setPhoneError]);

    const validateAndFormatPhone = useCallback((phone) => {
        const cleanedPhone = phone.replace(/[\s-]/g, "")
        const isValidPhone = /^(?:\+|00)[1-9]\d{9,14}$/.test(cleanedPhone)

        if (!cleanedPhone) {
            memoizedSetPhoneError(false)
            return ''
        } else if (isValidPhone) {
            memoizedSetPhoneError(false)
            return formatPhoneNumber(cleanedPhone)
        } else {
            memoizedSetPhoneError(true)
            return phone;
        }
    }, [memoizedSetPhoneError]);

    const formatPhoneNumber = (phone) => phone.replace(/[^\d+]/g, "")


    useEffect(() => {
        if (userData && (prevData?.userData !== userData)) {
            let number = findNumber(userData)
            let address = findAddress(userData)
            let newAppointment = { ...appointment, email: address, phone: validateAndFormatPhone(number) }
            setAppointment(newAppointment)
        }
    }, [appointment, prevData, setAppointment, userData, validateAndFormatPhone])

    const handleChange = (e) => {
        const { name, value } = e.target

        setAppointment((prev) => ({
            ...prev,
            [name]: name === "phone" ? validateAndFormatPhone(value) : value,
        }))
    }

    const findNumber = (data) => {
        let result = ''
        if (data.length > 0) {
            const privateCellphone = data.find(obj => (obj.type === "cellphone" && obj.isPrivate && obj.value))
            const cellphone = data.find(obj => (obj.type === "cellphone" && !obj.isPrivate && obj.value))
            const phone = data.find(obj => (obj.type === "phone" && !obj.isPrivate && obj.value))
            result = privateCellphone?.value || cellphone?.value || phone?.value || ''
        }
        return result
    }

    const findAddress = (data) => {
        let result = ''
        if (data.length > 0) {
            const email = data.find(obj => (obj.type === "email" && !obj.isPrivate && obj.value))
            const privateEmail = data.find(obj => (obj.type === "email" && obj.isPrivate && obj.value))
            result = email?.value || privateEmail?.value || ''
        }
        return result
    }

    return (
        <>
            {appointment && (
                <>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>{t('comment')}</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows="1"
                                    name="comment"
                                    placeholder={t('comment')}
                                    onChange={handleChange}
                                    value={appointment.comment}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>{t('email')}*</Form.Label>
                                <Form.Control
                                    name="email"
                                    type="email"
                                    placeholder="Enter email"
                                    value={appointment.email}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>{t('appointment:telephone')}*</Form.Label>
                                <Form.Control
                                    name="phone"
                                    type="tel"
                                    placeholder={t('appointment:labelTelephone')}
                                    value={appointment.phone}
                                    onChange={handleChange}
                                    isInvalid={phoneError}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {t('appointment:invalidTelephone')} <br /> {t('appointment:inValidTelephone2')}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                </>
            )}
            <MandatoryField />
        </>
    )
}

export default UserData
